import Spinner from './Spinner.jsx';
import EmptyState from './EmptyState.jsx';

/**
 * columns: [{ key, header, render?, className? }]
 * Rendering is kept dumb on purpose - filtering and paging stay in the page.
 */
const DataTable = ({ columns, rows, loading, emptyTitle, emptyDescription, onRowClick, rowKey = (row) => row.id }) => {
  if (loading) return <Spinner />;
  if (!rows?.length) return <EmptyState title={emptyTitle} description={emptyDescription} />;

  return (
    <div className="table-wrap">
      <table className="table">
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.key} className={column.className}>
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr
              key={rowKey(row)}
              onClick={onRowClick ? () => onRowClick(row) : undefined}
              className={onRowClick ? 'table__row--clickable' : undefined}
            >
              {columns.map((column) => (
                <td key={column.key} className={column.className}>
                  {column.render ? column.render(row) : row[column.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;
